module.exports = __webpack_public_path__ + "img/3_38.284b0f90.png";